import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { authInitialState } from './auth.constants';

const authSlice = createSlice({
  name: 'auth',
  initialState: authInitialState,
  reducers: {
    setAccessToken: (state, action: PayloadAction<string>) => {
      state.accessToken = action.payload;
    },
    clearTokens: (state) => {
      state.accessToken = null;
    },
  },
});

export const { setAccessToken, clearTokens } = authSlice.actions;
export const authReducer = authSlice.reducer;
